import * as React from "react";

function SvgPlusCircleIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 194" {...props}><path d="M96.9 2c-52.4 0-95 42.6-95 95s42.6 95 95 95 95-42.6 95-95-42.6-95-95-95zM151 104.5h-46.6v46.6h-15v-46.6H42.8v-15h46.6V42.9h15v46.6H151v15z" /></svg>;
}

export default SvgPlusCircleIcon;